/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Db_Desc2Inputs */

const en_svc_backend_development_db_desc2 = /** @type {(inputs: Svc_Backend_Development_Db_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostgreSQL schema design, indexes, and query planning so endpoints stay fast as data grows, not just at 10 rows.`)
};

const ar_svc_backend_development_db_desc2 = /** @type {(inputs: Svc_Backend_Development_Db_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصميم مخطط PostgreSQL وفهارس وتخطيط استعلامات حتى تبقى نقاط النهاية سريعة مع نمو البيانات.`)
};

const bn_svc_backend_development_db_desc2 = /** @type {(inputs: Svc_Backend_Development_Db_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostgreSQL স্কিমা ডিজাইন, ইন্ডেক্স ও কুয়েরি প্ল্যানিং, যাতে ডেটা বাড়লেও এন্ডপয়েন্ট দ্রুত থাকে, শুধু ১০ রোতে নয়।`)
};

const de_svc_backend_development_db_desc2 = /** @type {(inputs: Svc_Backend_Development_Db_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostgreSQL-Schemadesign, Indizes und Abfrageplanung, damit Endpunkte auch bei Datenwachstum schnell bleiben und nicht nur bei 10 Zeilen.`)
};

const es_svc_backend_development_db_desc2 = /** @type {(inputs: Svc_Backend_Development_Db_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diseño de esquemas, índices y planificación de consultas de PostgreSQL para que los endpoints se mantengan rápidos a medida que crecen los datos, no solo con 10 filas.`)
};

const fr_svc_backend_development_db_desc2 = /** @type {(inputs: Svc_Backend_Development_Db_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conception de schémas PostgreSQL, index et planification des requêtes pour que les endpoints restent rapides quand les données grossissent, pas seulement à 10 lignes.`)
};

const pt_svc_backend_development_db_desc2 = /** @type {(inputs: Svc_Backend_Development_Db_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design de esquema, índices e planejamento de consultas do PostgreSQL para que os endpoints permaneçam rápidos à medida que os dados crescem, não apenas em 10 linhas.`)
};

const zh_svc_backend_development_db_desc2 = /** @type {(inputs: Svc_Backend_Development_Db_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostgreSQL 结构设计、索引和查询规划，让接口在数据增长时依然飞快，而不只在 10 行数据时。`)
};

const tr_svc_backend_development_db_desc2 = /** @type {(inputs: Svc_Backend_Development_Db_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PostgreSQL şema tasarımı, index'ler ve sorgu planlamayla uç noktalar veri büyürken de hızlı kalır, yalnızca 10 satırda değil.`)
};

const ru_svc_backend_development_db_desc2 = /** @type {(inputs: Svc_Backend_Development_Db_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проектирование схемы PostgreSQL, индексы и планирование запросов, чтобы эндпоинты оставались быстрыми с ростом данных, а не только на 10 строках.`)
};

const pl_svc_backend_development_db_desc2 = /** @type {(inputs: Svc_Backend_Development_Db_Desc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektowanie schematów PostgreSQL, indeksy i planowanie zapytań, żeby endpointy trzymały tempo przy rosnących danych, nie tylko przy 10 wierszach.`)
};

/**
* | output |
* | --- |
* | "PostgreSQL schema design, indexes, and query planning so endpoints stay fast as data grows, not just at 10 rows." |
*
* @param {Svc_Backend_Development_Db_Desc2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_db_desc2 = /** @type {((inputs?: Svc_Backend_Development_Db_Desc2Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Db_Desc2Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_db_desc2(inputs)
	if (locale === "bn") return bn_svc_backend_development_db_desc2(inputs)
	if (locale === "de") return de_svc_backend_development_db_desc2(inputs)
	if (locale === "es") return es_svc_backend_development_db_desc2(inputs)
	if (locale === "fr") return fr_svc_backend_development_db_desc2(inputs)
	if (locale === "pt") return pt_svc_backend_development_db_desc2(inputs)
	if (locale === "zh") return zh_svc_backend_development_db_desc2(inputs)
	if (locale === "tr") return tr_svc_backend_development_db_desc2(inputs)
	if (locale === "ru") return ru_svc_backend_development_db_desc2(inputs)
	if (locale === "pl") return pl_svc_backend_development_db_desc2(inputs)
	return en_svc_backend_development_db_desc2(inputs)
});
export { svc_backend_development_db_desc2 as "svc_backend-development_DB_desc" }